






































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { LobbyMember } from "./lobby";
import { POSITION_NAMES, roleImage as constantRoleImage } from "../../constants";
import Root from "../root/root";

@Component
export default class LobbyMemberComponent extends Vue {
    $root: Root;

    @Prop()
    member: LobbyMember;

    @Prop()
    showPositions: boolean;

    @Prop()
    showModeration: boolean;

    get summonerIcon(): string {
        return `https://ddragon.leagueoflegends.com/cdn/${this.$root.ddragonVersion}/img/profileicon/${this.member.summoner.profileIconId}.png`;
    }

    get positions(): string {
        const [first, second] = [this.member.firstPositionPreference, this.member.secondPositionPreference];
        if (first === second && first === "UNSELECTED") return "<i>No Roles Selected</i>";
        if (first !== "FILL") {
            return POSITION_NAMES[first] + " - " + (second === "UNSELECTED" ? "<i>Empty</i>" : POSITION_NAMES[second]);
        }

        return "Fill";
    }

    // Import the roleImage helper from constants.
    roleImage = constantRoleImage;
}
